import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../../RoutesWithAuth';
import axios from '../../../common/AxiosConfig';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Tab, Tabs } from '@mui/material';
import { Button, CircularProgress, Typography, } from '@mui/material';
import { horizontalTabStyles } from '../sharedStyles';
import FormGroup from '../FormGroup';
import { v2UIRoutePath } from '../../../common/commons';
import ViewGeneratedJson from './ViewGeneratedJSON'
import { getAutoDSRCreateFields, DEACTIVATE_ACCOUNT_REQUEST_TYPE } from '../home/constant';
import { ADMIN_PERMISSIONS } from '../../../common/RolePermissions';
import PermissionButton from '../PermissionButton';

const useStyles = makeStyles(() => ({
    documentWrapper: {
        height: 'calc( 100% )'
    },
    createDsrRequest: {
        marginTop: '10px',
        padding: '0px 0px 10px 0px',
        boxShadow: '0px 0px 1px 0px rgb(0 0 0 / 41%)',
        height: 'calc( 100% - 60px )',
        marginRight: '10px',
        '& .header': {
            background: '#7f9ed7',
            padding: '5px',
            color: "white",
            fontWeight: 'bold'
        },
        '& .invalid-feedback': {
            width: '100%',
            display: 'block !important',
            marginTop: '0.25rem',
            marginLeft: '0.25rem',
            fontSize: '100%',
            color: '#dc3545'
        }
    },
    frameWrapper: {
        height: 'calc( 100% - 44px )'
    },
    createdsrHeader: {
        padding: '10px 20px',
        fontSize: '1rem',
        fontWeight: 'bold'
    },
    wrapper: {
        marginTop: "8px",
        position: 'relative',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        '& label': {
            textAlign: 'left'
        }
    },
    buttonProgress: {
        color: 'green',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    actionButton: {
        textTransform: 'initial'
    },
    appsScopeWrapper: {
        ...horizontalTabStyles.tabWrapper,
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    }

}));

function CreateDSAR() {
    const navigate = useNavigate();
    const location = useLocation();
    const classes = useStyles()
    const [json, setJson] = useState()
    const [users, setUsers] = useState([]);
    const [error, setError] = useState(null);
    const [generateJSONError, setGenerateJSONError] = useState(null);
    const [assignedTo, setAssignedTo] = useState('');
    const [dsar_id, setDsarId] = useState('');
    const [processing, setProcessing] = useState(false);
     const [generateProcessing, setGenerateProcessing] = useState(false);
    
    const [verticalTab, setVerticalTab] = useState(0);

    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const userId = context.userId.get
    const isAdmin = context.isAdmin.get

    useEffect(() => {
        if (location?.state?.cloneJson) {
            setJson(location.state.cloneJson);
            setVerticalTab(1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.state?.cloneJson])

    useEffect(() => {
        fetchData()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken])


    const handleClearForm = () => {
        setJson(null);
        setGenerateJSONError(null);
        setError(null);
    }

    const getApiErrorMessage = (err) => {
        const responseData = err?.response?.data;
        const error = responseData?.error;
        const message = responseData?.message;

        const normalizedMessage = typeof message === 'string' ? message.split('\n')[0] : '';
        const normalizedError = typeof error === 'string' ? error : '';

        if (normalizedError.includes("Error 522 Bad Gateway")) {
            return `${normalizedMessage} --- CTPs /v5/vehicle endpoint returned an error: Error 522 Bad Gateway`;
        }

        if (normalizedError.includes("APIGW-401")) {
            return `${normalizedMessage} --- CTP Vehicle API endpoint returned an error: Unauthorized - Access Denied`;
        }

        if (normalizedError.includes("Failed validating")) {
            return `${normalizedMessage} --- JSON Validation Failed due to incorrect schema, pls check logs for info`;
        }

        if (normalizedError && normalizedMessage) {
            return `${normalizedMessage} --- ${normalizedError}`;
        }

        if (normalizedMessage) {
            return normalizedMessage;
        }

        if (normalizedError) {
            return normalizedError;
        }

        if (Array.isArray(responseData?.errors) && responseData.errors.length) {
            return responseData.errors.join(', ');
        }

        return err?.message || 'Something went wrong while processing the request.';
    }

    const failGenerateJSON = (errorMessage) => {
        setJson(null);
        setGenerateJSONError(errorMessage);
        return false;
    }

    const handleDsarGenerateJSON = (formData) => {
        const isDriver = formData.requestor === 'Driver';
        const isDeactivateAccount = !isDriver && formData.request_type === DEACTIVATE_ACCOUNT_REQUEST_TYPE;
        if (isDriver) {
            if (!formData.dsar_id || !formData.vin || !formData.tc_case_number) {
                return failGenerateJSON('Please enter mandatory fields.');
            }
        } else if (isDeactivateAccount) {
            if (!formData.dsar_id || !formData.first_name || !formData.last_name || !formData.bec_number) {
                return failGenerateJSON('Please enter mandatory fields.');
            }
            if (!formData.guids || formData.guids.length === 0) {
                return failGenerateJSON('GUID is a mandatory attribute for Deactivate Account');
            }
        } else if (isDeactivateAccount) {
            if (!formData.dsar_id || !formData.first_name || !formData.last_name || !formData.bec_number) {
                setGenerateJSONError('Please enter mandatory fields.');
                return false;
            }
            if (!formData.guids || formData.guids.length === 0) {
                setGenerateJSONError('GUID is a mandatory attribute for Deactivate Account');
                return false;
            }
        } else {
            if (!formData.dsar_id || !formData.request_type || !formData.first_name || !formData.last_name || !formData.vin || !formData.bec_number) {
                return failGenerateJSON('Please enter mandatory fields.');
            }
        }
        const alphanumericRegex = /^[a-zA-Z0-9]*$/;
        if (!isDeactivateAccount) {
            if (!alphanumericRegex.test(formData.vin)) {
                return failGenerateJSON('Special characters or Spaces are not allowed in VIN');
            }
            if (formData.vin.length !== 17) {
                return failGenerateJSON("VIN should be 17 digits");
            }
        }
        if (!isDriver) {
            // Validate BEC Case # - https://toyotaconnected.atlassian.net/browse/DSAR2-4008
            if (!alphanumericRegex.test(formData.bec_number)) {
                return failGenerateJSON('Special characters or spaces are not allowed in BEC Case #');
            }
        }
        if (isDriver && !alphanumericRegex.test(formData.tc_case_number)) {
            return failGenerateJSON('Special characters or spaces are not allowed in TC Case #');
        }
        setGenerateProcessing(true)
        setDsarId(formData.dsar_id)
        setGenerateJSONError('')
        let payload;
        if (isDriver) {
            payload = {
                dsar_id: formData.dsar_id,
                vin: formData.vin,
                requestor: formData.requestor,
                request_type: 'Terminate-Vehicle-Location-Access',
                tc_number: formData.tc_case_number
            };
        } else {
            payload = { ...formData };
            if (isDeactivateAccount) {
                delete payload.vin;
            }
        }
        axios.post('/ticket/generate_payload', {
            ...payload
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setGenerateProcessing(false)
            setJson(res.data);
        }).catch(err => {
            console.log('There was an error creating json!', err)
            const errorMessage = getApiErrorMessage(err);

            failGenerateJSON(errorMessage);
            setGenerateProcessing(false)
        })


    }

    const handleDsarCreate = () => {

        if (!json || (json && json.trim()) === "") {
            setError({
                errorMessage: 'Please enter valid JSON.'
            });
            return false;
        }
        setProcessing(true)

        axios.post('ticket', {
            creatorId: userId,
            assigned_to: assignedTo === "" ? null : assignedTo,
            body: json
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setProcessing(false)
            navigate(`${v2UIRoutePath}requestdetails/${res.data.id ? res.data.id : res.data.dsar_id}`, { replace: true })
        }).catch(err => {
            console.log('There was an error creating the ticket!', err)
            const errorMessage = getApiErrorMessage(err);
            let existingDsrid;
            if (err?.response?.data?.dsar_id) {
                existingDsrid = err.response.data.dsar_id;
            }
            setError({
                errorMessage,
                id: existingDsrid
            });
            setProcessing(false)
        })
    }
    const fetchData = () => {
        // Get the list of all users
        axios.get('users', {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            if (res.data.length) {
                const filteredUsers = res.data.filter(user => user.user_status === 'Y' && !user.is_disabled);
                setAssignedTo(userId)
                setUsers(filteredUsers)
            }
        }).catch(err => {
            console.log('There was an error fetching users!', err)
        })
    }
    const isAuto = verticalTab === 0;
    return (
        <div className={classes.documentWrapper}>
            <Typography variant="h6" className={classes.createdsrHeader}>
                CREATE DSAR REQUEST
            </Typography>
            <div className={classes.appsScopeWrapper}>
                <Tabs

                    variant="scrollable"
                    value={verticalTab}
                    onChange={(_event, newValue) => {
                        setVerticalTab(newValue);

                    }}
                    aria-label="Vertical tabs"
                    sx={{ borderRight: 1, borderColor: 'divider' }}
                >
                    <Tab label={"Auto"} key={"auto"} />
                    <Tab label={"Manual"} key={"manual"} />

                </Tabs>
            </div>
            <div className={classes.createDsrRequest}>
                <div className={"header"}>
                    {isAuto ? "PARAMETERS" : "DSAR JSON"}
                </div>

                {isAuto && (<FormGroup
                    formWrapperClassName={classes.wrapper}
                    fields={getAutoDSRCreateFields()}
                    submitButtonText="Generate"
                    submitPermission={ADMIN_PERMISSIONS.DSAR_AUTO_GENERATE}
                    cancelButtonText="Clear"
                    customFormUpdates={(formData) => {
                        setJson(JSON.stringify({
                            "dsar_id": formData.dsar_id
                        }, null, 2))
                    }}
                    refreshGridWithSearch={handleDsarGenerateJSON}
                    handleClearForm={handleClearForm}
                />)}

                {isAuto && generateJSONError ? (
                    <div className="invalid-feedback" >
                        {generateJSONError}
                    </div>) : ""
                }
                {isAuto ? <ViewGeneratedJson json={json ? JSON.parse(json) : json} dsarRequestId={dsar_id} processing={generateProcessing} /> :
                    <textarea className={`${error && "is-invalid"} form-control`} id="JSON" rows="20" placeholder="Enter valid JSON here..."
                        value={json} onChange={e => { setJson(e.target.value) }} required>
                    </textarea>
                }
                {error && (
                    <>
                        <div className="invalid-feedback" id="error-message">
                            {error.errorMessage}
                        </div>
                        {error.id && (<Link to={`${v2UIRoutePath}requestdetails/${error.id}`}>View Existing Ticket</Link>)}
                    </>
                )}
                <div  >
                    <FormGroup
                        formWrapperClassName={classes.wrapper}
                        fields={[{
                            type: 'multiselect',
                            name: 'assign_to',
                            label: 'Assign To',
                            options: users.map(user => {
                                return {
                                    id: user.user_id,
                                    user_name: `${user.first_name} ${user.last_name}`
                                }
                            }),
                            removeCheckBox: true,
                            displayOption: 'user_name',
                            defaultOption: assignedTo
                        }]}
                        disableFormActions={true}
                        customFormUpdates={(formData) => {
                            setAssignedTo(formData.assign_to)
                        }}
                    />
                </div>
                <div className={classes.wrapper}>
                    <PermissionButton
                        disabled={processing}
                        className={classes.actionButton}
                        onClick={handleDsarCreate}
                        variant="contained"
                        color="primary"
                        data-testid="createdsar"
                        permission={verticalTab === 0 ? ADMIN_PERMISSIONS.DSAR_AUTO_CREATE : ADMIN_PERMISSIONS.DSAR_MANUAL_CREATE}
                    >
                        Create
                    </PermissionButton>
                    {processing && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>

            </div>

        </div>
    );
}
export default CreateDSAR;